<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :fromBackend="true"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import PrivateHealthData from '@/data/company-page-data/mapfre-sigorta/cross-pages/HealthInsurance'
export default {
  metaInfo: {
    title: 'Mapfre Sigorta Özel Sağlık Sigortası Fiyatları İçin Teklif Alın',
    meta: [
      {
        name: 'description',
        content: 'Mapfre Sigorta özel sağlık sigortası fiyatları için tıklayın! Bireysel sağlık sigortası ile ortaya çıkabilecek sağlık giderlerinizi güvence altına alın.'
      }
    ]
  },
  name: 'MapfreSigortHealthInsurance',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: PrivateHealthData.headerContent,
      crossPageContent: PrivateHealthData.crossPageContent,
      faqTitle: PrivateHealthData.faqTitle,
      faqTitleDesc: PrivateHealthData.faqTitleDesc,
      getPrice: PrivateHealthData.getPrice
    }
  }
}
</script>
